import React from 'react';

export const DropdownContext = React.createContext([]);
export const PermissionsContext = React.createContext([]);
export const ErrorContext = React.createContext({});
export const BrowserContext = React.createContext({});
export const NotificationContext = React.createContext([]);

const Constants = {
   nullPath: 'NullPath',
};

export default Constants;

export const MilestoneTypes = [
  { value: 0, label: 'Initiative Step' },
  { value: 1, label: 'Stakeholder Review' }, // SOX Review
  { value: 2, label: 'Stakeholder Review' }, // IT Review
  { value: 3, label: 'Stakeholder Review' }, // HR Review
  { value: 4, label: 'Stakeholder Review' }, // FSSG Review
  { value: 5, label: 'Delivery Step' },
  { value: 6, label: 'Embed Phase Review' },
  { value: 7, label: 'Stakeholder Review' }, // Operation Services Review
  { value: 8, label: 'Stakeholder Review' }, // Shared Services Finance Review
  { value: 9, label: 'Stakeholder Review' }, // Organizational Change Management Review
  { value: 10, label: 'Stakeholder Review' }, // Scientific Research and Experimental Development (SR&D) Review
  { value: 11, label: 'Stakeholder Review' } // Supply Chain Management Review
];

export const MilestoneStatus = [
  { value: 1, label: 'Not Started' },
  { value: 2, label: 'Started' },
  { value: 3, label: 'Completed' },
  { value: 4, label: 'Cancelled' },
  { value: 5, label: 'Resubmitted' }
  
];

export const InitiativeStatus = {
    AIM: 'Aim',
    BUILD_SUBMITTED: 'Submitted to Build',
    BUILD: 'Build',
    CONFIRM_SUBMITTED: 'Submitted to Confirm',
    CONFIRM: 'Confirm',
    DELIVER_SUBMITTED: 'Submitted to Deliver',
    DELIVER: 'Deliver',
    EMBED_SUBMITTED: 'Submitted to Embed',
    EMBED: 'Embed',
    ON_HOLD: 'On Hold',
    CANCELLED: 'Cancelled'
};

export const NOTIFICATION_TYPE = {
  COMMENTS: 'COMMENTS',
  VALUES: 'VALUES',
  INITIATIVE: 'INITIATIVE',
  MILESTONE: 'MILESTONE',
  KPI: 'KPI',
  TEAM_MEMBER: 'TEAM_MEMBER',
  ATTACHMENT: 'ATTACHMENT',
  APPROVAL: 'APPROVAL',
  TAG: 'TAG'
};
